import React from 'react';
import * as cls from './reviews.module.css';
import { Typography } from '../../../ui/components/typography/typography';
import { Reviews as UIReviews } from '../../../ui/layouts/reviews';

export const Reviews = () => {
  return (
    <section className={`${cls.section} ${cls['background--contrast']}`}>
      <Typography className={cls.title} tag="h2">
        Verified Customer Reviews
      </Typography>

      <UIReviews />
    </section>
  );
};
